import React from 'react';
import MemberView from './telegram/MemberView';
import AdminView from './telegram/AdminView';

function TelegramView({
    user,
    isAdmin,
    events,
    selectedEvent,
    selectedEventId,
    setSelectedEventId,
    selectedRegistration,
    onRegistrationSuccess,
    error
}) {
    return (
        <div className="container">
            <div className="welcome-box">
                WELCOME, {user?.profile?.displayName || user?.telegram?.firstName || 'FIGHTER'}
            </div>

            {error && (
                <div style={{ color: '#ff6b6b', marginTop: '1rem' }}>
                    {error}
                </div>
            )}

            {isAdmin ? (
                <AdminView />
            ) : (
                <MemberView
                    events={events}
                    selectedEvent={selectedEvent}
                    selectedEventId={selectedEventId}
                    setSelectedEventId={setSelectedEventId}
                    selectedRegistration={selectedRegistration}
                    onRegistrationSuccess={onRegistrationSuccess}
                />
            )}
        </div>
    );
}

export default TelegramView;